module.exports = __webpack_public_path__ + "static/media/certificate-color.4d452fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/certificate-color.jpg
// module id = 1925
// module chunks = 0